<template>
    <b-input-group>
        <b-input-group-prepend>
            <b-input-group-text>
                +1
            </b-input-group-text>
        </b-input-group-prepend>
        <b-input
            :value="value"
            :disabled="disabled"
            @input="emitInput"
            placeholder="(---) --- ----"
        ></b-input>
    </b-input-group>
</template>
<script>
export default {
    name    :   "phone-input",
    props   :   [
                    "value",
                    "disabled"
                ],
    data    ()  {
                    return  {
                                localValue    :   this.value
                            }; 
                },
    methods :   {
                    emitInput (value)
                            {         
                                this.$emit("input", this.formatNumber(value));
                            },
                    formatNumber(value)
                            {
                                value = value.replace(/[^\d]/g, "");
                                if (value.length == 10) {
                                    return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
                                }
                                return value;
                            }
                }
}
</script>